import {RatesType} from 'app/store/DepositsStore';

export const getRateByCurrency = (currency: string, rates: RatesType): number => currency && currency !== 'USD'
    ? rates[`${currency.toLowerCase()}_rate`]
    : null;
